import axios from "axios";
import axiosRetry from 'axios-retry';
import { IUserInfo } from "../interfaces/UserInfo";
import { appInsights } from "../helpers/appInsights";
import { generateUID } from "../helpers/GenerateUniqueId";
import { shouldRetryAxiosRequest } from "../hooks/utils";

export const AUTH_URL = "https://login.microsoftonline.com/335a6d75-c3eb-4b1a-ac08-d49338816ca0/v2.0";

export const CLIENT_ID =
process.env.REACT_APP_ENVIRONMENT === "development" ||
process.env.REACT_APP_ENVIRONMENT === "local"
? "a643b447-06a7-4136-b813-d688424928c2"
: process.env.REACT_APP_ENVIRONMENT === "qa"
? "2509089f-c347-49c2-b76e-fac1e6d07082"
: "2b249e6c-4e9f-4bc6-b835-971e38bb3e5f";

export const SCOPE_ID =
process.env.REACT_APP_ENVIRONMENT === "development" ||
process.env.REACT_APP_ENVIRONMENT === "local"
? "api://d80fe8e0-caed-49b2-a587-2e2373cffccf/.default"
: process.env.REACT_APP_ENVIRONMENT === "qa"
? "api://828fa002-bc96-4540-ad1a-491b7e4e1b6f/.default"
: "api://de14001a-6f62-4fe1-9ac0-964928002b24/.default";

let directSiteUrl: string = "";
let frontDoorSiteUrl: string = "";
const directSiteDomain: string = "azurewebsites.net";

switch (process.env.REACT_APP_ENVIRONMENT) {
  case "development":
    directSiteUrl = "https://cso-tec-dev-web.azurewebsites.net";
    frontDoorSiteUrl = "https://tectool-dev.hcahealthcare.cloud";
    break;
  case "qa":
    directSiteUrl = "https://cso-tec-qa-web.azurewebsites.net";
    frontDoorSiteUrl = "https://tectool-qa.hcahealthcare.cloud";
    break;
  case "production":
    directSiteUrl = "https://cso-tec-prod-web.azurewebsites.net";
    frontDoorSiteUrl = "https://tectool-prod.hcahealthcare.cloud";
    break;
}

export const APP_URL = window.location.hostname.indexOf(directSiteDomain) > 0
  ? directSiteUrl : frontDoorSiteUrl;

// export const APP_URL = "https://localhost:3000";

export const EPTAC_URL = 
process.env.REACT_APP_ENVIRONMENT === "development" ||
process.env.REACT_APP_ENVIRONMENT === "local" ||
// We are wanting to use ePTAC's QA environment even in development and local
process.env.REACT_APP_ENVIRONMENT === "qa"
? "https://ptac.hcaqa.corpadqa.net"
: "https://ptac.hca.corpad.net"
	
export const baseURL = process.env.REACT_APP_BASE_URL;

let user34 = "";
export function setAxiosUser(user: string) {
	user34 = user;
}

export const AUTH_API = axios.create({
	baseURL: AUTH_URL,
});

const API = axios.create({
	baseURL,
});

axiosRetry(API, {
    retries: 3,
    retryDelay: (retryCount) => {
		return 2000; //Delay for 2 Sec
	  },
	  retryCondition: shouldRetryAxiosRequest,
});

// Add a unique Id for each request to correlate API error in backend
API.interceptors.request.use(
    config => {
      config.headers['RequestId'] = generateUID();
          return config;
      },
      error => {
          return Promise.reject(error);
      }
  );

API.interceptors.request.use(
	(successfulReq) => {
		if (
			successfulReq.method === "post" ||
			successfulReq.method === "put" ||
			successfulReq.method === "delete"
		) {
			successfulReq.data = {
				...successfulReq.data,
				modifiedBy: user34,
			};
		}
		return successfulReq;
	},
	(error) => {
		return Promise.reject(error);
	}
);

const responseHandler = (response: any) => {
	if (response.status === 401) {
		//window.location = "/login";
	}
	return response;
};

const errorHandler = (error: any) => {
	 // Logging the exception into appinsights
	 var data = "";
	 if (error.config.data !== undefined && error.config.data !== '') {
		 data = JSON.parse(error.config.data);
	 }
 
	 var detailedErrorMessage = "";
	 if (error.request.responseText !== undefined && error.request.responseText !== '') {
		 detailedErrorMessage = error.request.responseText;
	 }

	var bearerheader = "";
	if (error.config.headers !== undefined && error.config.headers !== '') {
		bearerheader = error.config.headers.Authorization;
	}

	var requestUniqueId = "";
	if (error.config.headers !== undefined && error.config.headers !== '') {
		requestUniqueId = error.config.headers.RequestId;
	}
 
	 let global: any = globalThis;
	 let userDetails: IUserInfo = Object.freeze(global.userDetails);
	 const properties = {
		 userId : userDetails?.userID,
		 requestId : requestUniqueId,
		 accessToken : bearerheader,
		 application : "TECToolUI",
		 apiUrl:error.config.url,
		 apiPayload:data,
		 errorCode : error.code,
		 errorMessage:error.message,
		 errorText:detailedErrorMessage
	 }
	 appInsights.trackException({ error: error, properties });
	 
	return Promise.reject(error);
};

API.interceptors.response.use(
	(response) => responseHandler(response),
	(error) => errorHandler(error)
);

export { API};
